import React from "react";

import { FormattedMessage } from "react-intl";
import { VerificationService } from "../../../lib/types/types";
import { FormFooterComponent } from "../../FormFooter/FormFooterComponent";

export interface IdCheckLoopOnfidoFooterProps {
  verificationService: VerificationService;
}

export const IdCheckLoopOnfidoFooter = ({ verificationService }: IdCheckLoopOnfidoFooterProps) => (
  <FormFooterComponent verificationService={verificationService}>
    <div>
      <p>
        <FormattedMessage
          id="step.idCheckLoop.terms"
          defaultMessage='By clicking "Continue", you agree you have read, understand, and accept {scanPolicy}, {privacyPolicyLink}, and {termsOfService}.'
          values={{
            scanPolicy: (
              <a
                href="https://onfido.com/facial-scan-policy-and-release/"
                target="_blank"
                rel="noopener noreferrer"
                className="sid-link"
              >
                <FormattedMessage
                  id="step.idCheckLoop.scanPolicy"
                  defaultMessage="Onfido Facial Scan Policy and Release"
                />
              </a>
            ),
            privacyPolicyLink: (
              <a
                href="https://www.onfido.com/privacy/"
                target="_blank"
                rel="noopener noreferrer"
                className="sid-link"
              >
                <FormattedMessage
                  id="step.idCheckLoop.privacyPolicy"
                  defaultMessage="Privacy Policy"
                />
              </a>
            ),
            termsOfService: (
              <a
                href="https://onfido.com/terms-of-service/"
                target="_blank"
                rel="noopener noreferrer"
                className="sid-link"
              >
                <FormattedMessage
                  id="step.idCheckLoop.termsOfService"
                  defaultMessage="Terms of Service"
                />
              </a>
            ),
          }}
        />
      </p>

      <p>
        <FormattedMessage id="companyName" defaultMessage="{Company}">
          {(companyName) => (
            <FormattedMessage
              id="step.idCheckLoop.disclaimer"
              defaultMessage="SheerID, {companyName}'s trusted partner, use a third party, {serviceType}, to process our identity check."
              values={{
                serviceType: "Onfido",
                companyName,
              }}
            />
          )}
        </FormattedMessage>
      </p>
    </div>
  </FormFooterComponent>
);

export default IdCheckLoopOnfidoFooter;
